import './stepper.scss';

import React from 'react';

export interface StepperCircleSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {}

function StepperCircleSpinner({
  className = '',
  ...props
}: StepperCircleSpinnerProps): JSX.Element {
  return (
    <div className={`.spinner stepper-circle-spinner ${className}`} role="status" {...props} />
  );
}

export default StepperCircleSpinner;
